import { FC } from 'react'
import { IconButton as ChakraIconButton, IconButtonProps as ChakraIconButtonProps } from '@chakra-ui/react'

export interface IconButtonProps {
  variant?: ChakraIconButtonProps['variant']
  label: string
  icon: ChakraIconButtonProps['icon']
  size?: ChakraIconButtonProps['size']
  onClick?: ChakraIconButtonProps['onClick']
}

export const IconButton: FC<IconButtonProps> = ({ label, icon, size = 'md', variant = 'ghost', onClick }) => (
  <ChakraIconButton
    aria-label={label}
    variant={variant}
    icon={icon}
    size={size}
    fontSize={size}
    borderColor={variant === 'outline' ? 'grey' : ''}
    onClick={onClick}
    tabIndex={0}
    _focus={{
      outline: '2px solid rgba(121, 206, 37)',
      boxShadow: '0 0 0 2px rgba(88, 158, 19)',
    }}
  />
)
